import {PIXI} from '@colonist/pixi'
import {UIGameManager} from '../ui_game/UIGameManager'
import {createDivIn, createExternalImgIn, createParagraphIn} from '../ui_utils/DomUtils'
import {EndGameState} from '@colonist/game-states'
import html2canvas from 'html2canvas-pro'

export abstract class UIBaseShareImage {
    protected readonly uiGameManager: UIGameManager
    protected readonly endGameState: EndGameState

    protected readonly extract: PIXI.IExtract

    protected readonly container: HTMLDivElement

    private imageGenerated: boolean = false
    private imageFile: File | undefined
    private convertImagePromise: Promise<File | undefined> | undefined

    constructor(uiGameManager: UIGameManager, endGameState: EndGameState) {
        this.uiGameManager = uiGameManager
        this.endGameState = endGameState

        this.extract = this.uiGameManager.canvasController.app.renderer.extract

        this.container = createDivIn(document.body, 'share-image-container')

        this.createLogo()
        this.createColonistLink()
    }

    async getImageFile(): Promise<File | undefined> {
        if(this.imageFile) return this.imageFile

        if(!this.imageGenerated) {
            await this.generateImage()
            this.imageGenerated = true
        }

        if(!this.convertImagePromise) this.convertImagePromise = this.convertImage()

        await this.convertImagePromise
        return this.imageFile
    }

    protected abstract generateImage(): void

    private async convertImage(): Promise<File | undefined> {
        const canvas = await html2canvas(this.container, {useCORS: true})

        return new Promise((resolve, reject) => {
            canvas.toBlob((blob) => {
                if(!blob) {
                    resolve(undefined)
                    return
                }
                this.imageFile = new File([blob], 'colonist-game-results.png', {type: blob.type})
                resolve(this.imageFile)
            }, 'image/png')
        })
    }

    private createLogo() {
        createExternalImgIn(this.container, '/dist/images/logo.svg?rev=', {key: 'strings:colonistCommon.utils.emptyString'}, 'share-image-logo')
    }

    private createColonistLink() {
        const linkContainer = createDivIn(this.container, 'share-image-url-container')
        createExternalImgIn(linkContainer, '/dist/images/icon_arrow_white.svg?rev=', {key: 'strings:colonistCommon.utils.emptyString'}, 'share-image-url-arrow')
        createParagraphIn(linkContainer, {key: 'strings:colonistCommon.utils.#buffer', options: {value: 'colonist.io'}}, 'share-image-url')
    }
}
